<template>
  <div class="homepage">
    <!-- 顶部信息 -->
    <div class="tob">
      <div class="hd"></div>
      <h1 class="dt">河南科技成果评价服务</h1>
      <div class="crm">
        <ul>
          <li>专业</li>
          <li>权威</li>
          <li>客观</li>
          <li>公正</li>
        </ul>
      </div>
      <div style="text-align: center;">
        <div style="margin-top: 15px;" class="aa">


          <el-input placeholder="请输入内容" v-model="state2" class="input" style="width: 30%">
            <el-select v-model="select" style="width: 110px" slot="prepend" placeholder="请选择" disabled>
              <el-option label="证书编号" value="1" style="padding: 0 20px"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" style="color: #fff; background-color:#3862cf;border:none;padding: 12px 20px"
                       @click="godata()"></el-button>
            <!--                    <el-button-->
            <!--                        style="color: #fff; background-color:#3862cf;border:none;padding: 12px 20px"-->
            <!--                        slot="append"-->
            <!--                        icon="el-icon-search"-->
            <!--                        @click="godata()"-->
            <!--                    ></el-button>-->
          </el-input>

          <!--                    <el-autocomplete
                                      class="inline-input"
                                      v-model="state2"
                                      style="width: 30%"
                                      :fetch-suggestions="querySearch"
                                      placeholder="请输入内容"
                                      :trigger-on-focus="false"
                                      @select="handleSelect"
                                      @input="aa()"
                              >
                                  <el-select
                                          style="width: 110px"
                                          v-model="select"
                                          slot="prepend"
                                          placeholder="请选择"
                                          @change="bb"
                                  >
                                      <el-option label="证书编号啊啊" value="1" style="padding: 0 20px"></el-option>
          &lt;!&ndash;                            <el-option label="成果名称12" value="2" style="padding: 0 20px"></el-option>&ndash;&gt;
                                  </el-select>
                                  <el-button
                                          style="color: #fff; background-color:#3862cf;border:none;padding: 12px 20px"
                                          slot="append"
                                          icon="el-icon-search"
                                          @click="godata()"
                                  ></el-button>
                              </el-autocomplete>-->
        </div>
      </div>
    </div>
    <!-- 菜单栏 -->
    <div class="menu">
      <div class="menubox">
        <span
            v-for="div in divs"
            :key="div.id"
            :class="{ highlight: div.active }"
            @click="activateDiv(div.id)"
        >
          {{ div.content }}
        </span>
      </div>
    </div>
    <!-- 内容 -->
    <div class="ct">
      <div v-if="page == 1" class="cooperate">
        <div class="tableTitle">
          <span class="midText">经典案例</span>
        </div>
        <div class="div1">
          <img src="~@/assets/img/12.jpg" alt=""/>
          <img src="~@/assets/img/13.jpg" alt=""/>
          <img src="~@/assets/img/18.png" alt=""/>
        </div>
        <div class="tableTitle">
          <span class="midText">合作单位</span>
        </div>
        <div class="div2">
          <img src="~@/assets/img/1.jpg" alt=""/>
          <img src="~@/assets/img/2.png" alt=""/>
          <img src="~@/assets/img/3.jpg" alt=""/>
        </div>
        <div style="padding: 20px 10px;" class="div2">
          <img src="~@/assets/img/007.png" alt=""/>
          <img src="~@/assets/img/011.png">
          <img src="~@/assets/img/009.png">
          <!--     <img style="max-width: 300px;" src="~@/assets/img/16.png" alt=""/>
               <img src="~@/assets/img/17.png" alt=""/>-->
        </div>
        <div style="padding: 20px 10px;" class="div2">
          <img style="" src="~@/assets/img/003.png" alt=""/>
          <!--                    <img   src="~@/assets/img/008.jpg">-->
          <img src="~@/assets/img/008.jpg">
          <img style="" src="~@/assets/img/010.png" alt=""/>
        </div>
      </div>
      <div v-if="page == 2" class="cooperate">
        <div class="tableTitle">
          <span class="midText">评价机构简介</span>
        </div>
        <div class="tex">
          <p>
            <!--                        河南知泓历经5年风雨，先后成立华川知识产权、郑州利贞知识产权、2022年1月份河南知泓知识产权运营有限公司正式挂牌运营!-->
            公司历经6年风雨，已成为中小企业公共服务示范平台。
          </p>
          <p>
            公司以客户至上服务第一为行为准则，形成以项目申报、财税服务为一体，专注为各类研发型企业提供全方位、多元化、专业化的项目申报咨询服务，服务咨询。
          </p>
          <p>
            公司拥有超50余专业技术人才，长期提供科技、工信、发改委、商务、农业、财政、税务等多个部门的政策咨询等优质服务。
          </p>
          <p>
            公司合作超300家大型企业，涵盖医疗、制造、设计、环保、机械、科技、艺术等行业，提供个性化定制服
            务!
          </p>
        </div>
        <div class="tableTitle">
          <span class="midText">服务流程</span>
        </div>
        <div class="liuc">
          <div class="horizontal-line">
            <div class="dashed" style="left: calc(0% - 1px)"></div>
            <div class="dashed" style="left: calc(100% - 1px)"></div>
            <div class="dashed-line" style="left: calc(10% - 1px)">
              <div class="licu-tex">
                1.科技成果评价咨询
              </div>
            </div>
            <div class="dashed-line" style="left: calc(23% - 1px)">
              <div class="licu-to">
                2.评价材料形式审查
              </div>
            </div>
            <div class="dashed-line" style="left: calc(36% - 1px)">
              <div class="licu-tex">
                3.签订评价委托协议
              </div>
            </div>
            <div class="dashed-line" style="left: calc(49% - 1px)">
              <div class="licu-to">
                4.遗选评价专家
              </div>
            </div>
            <div class="dashed-line" style="left: calc(62% - 1px)">
              <div class="licu-tex">
                5.召开评价会议
              </div>
            </div>
            <div class="dashed-line" style="left: calc(75% - 1px)">
              <div class="licu-to">
                6.做出评价结论
              </div>
            </div>
            <div class="dashed-line" style="left: calc(90% - 1px)">
              <div class="licu-tex">
                7.交付评价报告
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="page == 4" class="cooperate">
        <div class="tableTitle">
          <span class="midText">评价报告作用</span>
        </div>
        <div class="bobax">
          <div>
            <img src="~@/assets/image/奖励.png" alt=""/>
            <h4>国家奖励</h4>
            <p>申报国家地方及行业科技奖项的重要佐证材料。</p>
          </div>
          <div>
            <img src="~@/assets/image/机构备份 2.png" alt=""/>
            <h4>政府支持</h4>
            <p>
              国务院印发的《“十三五”国家科技创新规划的通知》中把第三方的评价结果作为财政科技经费支持的重要依据。
            </p>
          </div>
          <div>
            <img src="~@/assets/image/organize_3.png" alt=""/>
            <h4>职称评定</h4>
            <p>
              是科研人员在职称晋升时，对其科研能力和研发水平评定的重要依据。
            </p>
          </div>
          <div>
            <img src="~@/assets/image/项目验收_验收.png" alt=""/>
            <h4>结题验收</h4>
            <p>
              是对科研项目研发目标的完成情况、成果的创新性和效益评判的重要依据。
            </p>
          </div>
          <div>
            <img src="~@/assets/image/Artboard Copy 29.png" alt=""/>
            <h4>行业认可</h4>
            <p>
              是在获取投资、融资、许可、转让合作中对成果价值评判的重要依据。
            </p>
          </div>
          <div>
            <img src="~@/assets/image/法规 天平.png" alt=""/>
            <h4>价值认定</h4>
            <p>
              是在获取投资、融资、许可、转让、合作中对成果价值评判的重要 依据。
            </p>
          </div>
          <div>
            <img src="~@/assets/image/沙漏.png" alt=""/>
            <h4>技术交易</h4>
            <p>有利减少技术交易中买卖双方的沟通和谈判成本，提高交易效率。</p>
          </div>
          <div>
            <img src="~@/assets/image/icon_recruit_ paid leave.png" alt=""/>
            <h4>市场推广</h4>
            <p>
              权威的专家意见和第三方评价报告，有利于技术成果快速在市场推广转化和产业化。
            </p>
          </div>
        </div>
        <div class="tableTitle">
          <span class="midText">核心优势</span>
        </div>
        <div class="advantage">
          <div>
            <img src="~@/assets/image/合作机构.png" alt=""/>
            <h4>权威机构</h4>
            <p>
              国家技术转移示范机构 <br/>
              国家级科技成果评价机构<br/>国家军民融合科技评估机构<br/>国家中小企业公共服务示范平台<br/>社会公共安全科技成果评价机构
            </p>
          </div>
          <div>
            <img src="~@/assets/image/professor教授.png" alt=""/>
            <h4>顶级专家</h4>
            <p>
              汇聚了来自国家发改委、科技部中国科学院、清华大学等单位的括院士、国务院参事、学术带头人、国家重点实验室负责人等组成的10000多人高层次、权威的专家团队。
            </p>
          </div>
          <div>
            <img src="~@/assets/image/盾牌锁.png" alt=""/>
            <h4>国家标准</h4>
            <p>
              与科技部有关部门、中国标准化研究院等单位共同制定了科技成果评价指标体系和科技成果评价操作规程，参与了多项有关科技成果评价的国家标准起草工作
            </p>
          </div>
          <div>
            <img src="~@/assets/image/服务_o.png" alt=""/>
            <h4>增值服务</h4>
            <p>
              提供包括国家科技成果评价、国家科技成果登记、国家科技奖励申报指导、财政资金专项申报指导、利技查新、检验检测、资本对接、技术转移、成果转化等全链条服务。
            </p>
          </div>
        </div>
      </div>
      <div v-if="page == 3" class="cooperate">
        <div class="tableTitle">
          <span class="midText">成果评价新规</span>
        </div>
        <div class="tex">
          <p class="navtex">
            2016年6月，科技部根据《国务院办公厅关于做好行政法规部门规章和文件清理工作有关事项的通知》
            (国办函[2016]
            12号)精神，按照依法行政、转变职能、加强监管、优化服务的原则决定对《科学技术成果鉴定办法》等规章予以废止。《科学技术成果鉴定办法》被废止后，根据科技部、教育部等五部委发布的《关于改进科学技术评价工作的决定》和科技部发布的《科学技术评价办法》的有关规定，今后各级科技行政管理部门不得再自行组织科技成果评价，科技成果评价工作由委托方委托第三方专业评价机构进行。
          </p>
        </div>
      </div>
      <div class="botton_no">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: black;">备案号：豫ICP备2024085024号-1</a>
      </div>
      <!--            <div class="botton_no">
                      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: black;">备案号：
                          豫ICP备2023001986号-1</a>
                  </div>-->
    </div>

  </div>
</template>

<script>

export default {
  name: 'HomeView',
  data() {
    return {
      restaurants: [],
      input: undefined,
      timer: null, // 用于临时存放计时器
      state2: '',
      select: '1',
      resultData: '',
      divs: [
        {id: '1', content: '合作案例', active: true},
        {id: '2', content: '机构简介', active: false},
        {id: '3', content: '评价新规', active: false},
        {id: '4', content: '评价优势', active: false}
      ],
      page: ''
    }
  },
  computed: {},
  watch: {},

  methods: {
    bb() {
      this.state2 = ''
      this.restaurants = []
    },
    aa() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        if (this.state2 !== '') {
          this.$request.get('/ky/tbInquirePlatform/getBlurData?code=' + this.select + '&itemCode=' + this.state2).then(res => {
            return this.restaurants = res.data
          })
        }
      }, 1000)
    },
    querySearch(queryString, cb) {
      setTimeout(() => {
        var restaurants = this.restaurants
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
        // 调用 callback 返回建议列表的数据
        cb(results)
      }, 2000)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1)
      }
    },
    handleSelect(item) {
      this.resultData = item.value
    },
    // 搜索
    godata() {
      this.$router.push({
        path: '/searchfor',
        query: {
          select: this.select,
          input: this.state2
        }
      })
    },

    // 菜单切换
    activateDiv(divId) {
      this.page = divId
      this.divs.forEach(div => {
        if (div.id === divId) {
          div.active = true
        } else {
          div.active = false
        }
      })
    },
    getZd() {
      this.$request.get('/sys/dict/getDictMap',).then(res => {
        localStorage.setItem('dictList', JSON.stringify(res.data || '[]'))
      })
    }
  },
  created() {
    this.getZd()
  },
  mounted() {
    this.restaurants = this.aa()
    this.divs.map(item => {
      if (item.active) {
        this.page = item.id
      }
    })
  },
  components: {}
}
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

.botton_no {
  text-align: center;
  padding: 20px;
}


ol,
ul {
  list-style: none;
}

//顶部信息
.tob {
  width: 100%;
  height: 500px;
  background-image: url("~@/assets/img/banner1.png");
  background-size: 100% 100%;
  color: #fff;

  .hd {
    height: 60px;

    background-color: #51525572;
    line-height: 60px;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    padding-left: 80px;
  }

  .dt {
    margin-top: 30px;
    width: 100%;
    text-align: center;
    font-size: 36px;
  }

  .crm {
    width: 100%;
    text-align: center;
    padding: 30px 0px;

    ul {
      height: 60px;
      width: 360px;
      display: block;
      margin: 0 auto;
      text-align: center;

      li {
        float: left;
        padding: 20px 20px;
        font-size: 25px;
        font-weight: 100;
      }
    }
  }

  .input-with-select {
    width: 600px;

    ::v-deep .el-input-group__append {
      background-color: #3862cf;
      border: none;
    }
  }
}


//菜单栏
.menu {
  width: 100%;
  height: 100px;
  margin-top: -40px;

  .menubox {
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 3px 22px 0 #d2d3da;
    background-color: #fff;
    width: 60%;
    margin: 0 auto;

    span {
      height: 100px;
      text-align: center;
      line-height: 100px;
      font-size: 24px;
      flex: 1;
      color: #000a64;
      cursor: pointer;
      float: left;
    }

    .highlight {
      background-color: #363c70;
      color: #fff;
      border-radius: 3px;
      transform: scale(1.2);
    }
  }
}


//内容
.ct {
  width: 60%;
  margin: 0 auto;
  height: 600px;
  margin-top: 70px;

  .cooperate {
    padding-bottom: 30px;
  }

  .tableTitle {
    position: relative;
    margin: 0 auto;
    height: 2px;
    background-color: #5f42ed;
    text-align: center;
    font-size: 16px;
    color: rgba(101, 101, 101, 1);
    background-image: linear-gradient(120deg,
    #f3f2f5 0%,
    #1f2777 50%,
    #eaedef 100%);
    margin-bottom: 30px;
  }

  .midText {
    position: absolute;
    left: 50%;
    background-color: #ffffff;
    padding: 0 30px;
    transform: translateX(-50%) translateY(-50%);
    font-size: 24px;
    color: #1f2777;
    font-weight: 600;
  }

  .div1 {
    width: 100%;
    height: 300px;
    padding: 30px 0;
    display: flex;
    justify-content: space-between;

    img {
      flex: 1;
      width: 30%;
      height: 200px;
    }

    img:nth-of-type(2) {
      margin: 0 20px;
    }
  }

  .div2 {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-evenly;

    img {
      flex: 1;
      width: 30%;
      height: 90px;
      padding: 10px;
    }
  }

  .liuc {
    width: 100%;
    height: 300px;
    position: relative;

    .horizontal-line {
      position: relative;
      top: 50%;
      left: 0;
      height: 3px;
      width: 100%;
      background-color: #190663;

      .dashed {
        width: 3px;
        height: 20px;
        border-bottom: 3px dashed;
        position: absolute;
        top: -8px;
        background-color: #190663;
      }

      .dashed-line {
        width: 3px;
        height: 70px;
        border-bottom: 3px dashed;
        position: absolute;
        top: -70px;
        background-color: #190663;

        .licu-tex {
          text-align: center;
          position: relative;
          top: -40px;
          left: -75px;
          width: 150px;
          height: 40px;
        }

        .licu-to {
          text-align: center;
          position: relative;
          top: 90px;
          left: -75px;
          width: 150px;
          height: 40px;
        }
      }

      .dashed-line:nth-child(2n) {
        transform: translateY(71px);
      }
    }
  }

  .tex {
    margin-bottom: 30px;

    p {
      padding: 10px 40px;
      line-height: 35px;
      text-indent: 24px;
      letter-spacing: 0.15em;
    }

    .navtex {
      line-height: 60px;
    }
  }

  .bobax {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;

    div {
      width: 23%;
      height: 280px;
      margin: 10px 10px;
      text-align: center;
      padding: 20px;

      img {
        display: block;
        height: 100px;
        margin: 0 auto;
        margin-bottom: 15px;
        padding: 10px;
      }

      h4 {
        margin-bottom: 15px;
        color: #190663;
      }

      p {
        text-align: left;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.1em;
        overflow: hidden; /*超出内容隐藏*/
        text-overflow: ellipsis; /*超出内容为省略号*/
        display: -webkit-box; /*内容不换行*/
        -webkit-line-clamp: 5; /*超出几行*/
        -webkit-box-orient: vertical; /*从上到下垂直排列子元素*/
      }
    }
  }

  .advantage {
    height: 400px;
    display: flex;
    justify-content: space-evenly;

    div {
      width: 23%;
      height: 340px;
      margin: 10px 10px;
      text-align: center;
      padding: 20px;
      box-shadow: 0 3px 22px 0 #d2d3da;

      img {
        display: block;
        height: 100px;
        margin: 0 auto;
        margin-bottom: 15px;
        padding: 10px;
      }

      h4 {
        margin-bottom: 15px;
        color: #190663;
      }

      p {
        text-align: left;
        font-size: 13px;
        line-height: 25px;
        letter-spacing: 0.06em;
        overflow: hidden; /*超出内容隐藏*/
        text-overflow: ellipsis; /*超出内容为省略号*/
        display: -webkit-box; /*内容不换行*/
        -webkit-line-clamp: 7; /*超出几行*/
        -webkit-box-orient: vertical; /*从上到下垂直排列子元素*/
      }
    }
  }
}

</style>

